'use client'

import { useTranslation } from '@/hooks/client/use-translation'
import { tw } from '@/lib/utils'

const SCORE_MAX = 5

interface RowSoundScoreProps {
  score: number | null
  className?: string
}

// The lab result as a labelled meter — "HearAdvisor SoundScore   4.6 / 5" over
// a lapis bar. A missing result stays words ("Not tested"), never an empty bar.
export const RowSoundScore = ({ score, className }: RowSoundScoreProps) => {
  const { t } = useTranslation()
  const tested = score != null && score > 0

  return (
    <div className={tw('min-w-0 text-[13px] leading-snug', className)}>
      <div className="flex items-baseline justify-between gap-3">
        <span className="text-navy/80">{t('directory.row.soundScore', 'HearAdvisor SoundScore')}</span>
        {tested ? (
          <span className="text-navy shrink-0 font-semibold tabular-nums">
            {t('directory.row.soundScoreValue', '{{score}} / 5', { score: score.toFixed(1) })}
          </span>
        ) : (
          <span className="text-navy/60 shrink-0 font-medium">
            {t('directory.row.soundScoreNotTested', 'Not tested')}
          </span>
        )}
      </div>
      {tested ? (
        <span aria-hidden className="bg-navy/10 mt-1.5 block h-1.5 overflow-hidden rounded-full">
          <span
            className="bg-lapis block h-full rounded-full"
            style={{ width: `${Math.min(100, (score / SCORE_MAX) * 100)}%` }}
          />
        </span>
      ) : null}
    </div>
  )
}
